import { MACROTREND, MICROTREND } from '@/model/trends/types'

export default {
    action: {
        [MACROTREND]: 'Add macro-trend to work spaces | Add macro-trends to work spaces',
        [MICROTREND]: 'Add micro-trend to work spaces | Add micro-trends to work spaces'
    },
    title: {
        [MACROTREND]: 'Macro-trend',
        [MICROTREND]: 'Micro-trend'
    },
    count: 'and one additional trend | and {count} additional trends',
    subtitle: 'Add to work spaces',
    submit: 'Done',
    success: {
        single: 'The trend <strong>"{title}"</strong> was successfully added to a work space.',
        bulk: 'The selected trends were successfully added to the following work spaces:'
    },
    createWorkspace: {
        title: 'Or: Create a new work space',
        label: 'Work space title'
    },
    error: 'An error occured: <strong>"{title}"</strong>.'
}
